module.exports = __webpack_public_path__ + "scripts/outline-icons.woff?7aaf5675";


//////////////////
// WEBPACK FOOTER
// ./semantic/dist/themes/default/assets/fonts/outline-icons.woff
// module id = 215
// module chunks = 1